/**
 * True when `error` carries the given HTTP status.
 *
 * Deliberately structural rather than `instanceof`: the app throws several
 * unrelated error shapes that all expose `status` (`AttensiFetchError` from
 * `customFetch`, `FastApiV1Error` from the hyperdrive path), and they share
 * no base class. Consumers care about the status, not the constructor.
 */
export const isHttpStatus = (error: unknown, status: number): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  error.status === status
